function About() {
    return (
        <div>
            <h2>Contact Us</h2>
            <div>
                <p>For all program and general enquiries contact us on: <a href="mailto:contact@ietbhec.com" target='_blank' rel="noreferrer noopener">contact@ietbhec.com</a></p>
            </div>
        </div>
    )
}

export default About